module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-dialog"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Dialog")]), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": _vm.handleAlertClick
    }
  }, [_vm._v("点击我打开alert提示框")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zan-button-1"
  }, [_c('zan-button', {
    on: {
      "click": _vm.handleConfirmClick
    }
  }, [_vm._v("点击我打开confirm提示框")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-562c8003!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/dialog.vue
// module id = 292
// module chunks = 0